import { createComponent } from '../lib';
import { VmLoadingScreen } from '@vime/core';
import { define } from '../lib';
define('vm-loading-screen', VmLoadingScreen);
;
export default createComponent('vm-loading-screen', new Set(['playbackReady', 'hideDots']));
